<div class="it-header-navbar-wrapper theme-light-desk">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <nav
          class="navbar navbar-expand-lg has-megamenu p-0"
          [attr.aria-label]="'MAIN_NAV' | translate"
        >
          <button
            [class.d-none]="!isAuth"
            #burgerButton
            class="custom-navbar-toggler"
            type="button"
            aria-controls="navC2"
            aria-expanded="false"
            [attr.aria-label]="'OPEN_NAVBAR' | translate"
            (click)="toggleNavbar()"
          >
            <svg aria-hidden="true" class="icon hamb-style">
              <use href="assets/sprite.svg#it-burger"></use>
            </svg>
          </button>
          <div class="navbar-collapsable" id="navC2" #navCollapsible>
            <div class="overlay"></div>
            <div class="close-div">
              <button class="btn close-menu" type="button" #closeButton>
                <span class="visually-hidden">{{
                  "CLOSE_MAIN_NAV" | translate
                }}</span>
                <svg aria-hidden="true" class="icon close">
                  <use href="assets/sprite.svg#it-close-big"></use>
                </svg>
              </button>
            </div>
            <!-- NAVBAR LOGGED -->
            <section
              class="menu-wrapper"
              *ngIf="isAuth"
              aria-labelledby="mainNavLogged"
            >
              <ul class="navbar-nav">
                <li class="nav-item">
                  <a
                    #navlink1
                    href="javascript:void(0)"
                    (click)="clearFocus(navlink1); changeTitle('Home')"
                    [routerLink]="['/servizi']"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }"
                    class="nav-link nav-link-custom"
                    [attr.aria-current]="
                      isExactRoute('/servizi') ? 'page' : null
                    "
                    ><span>{{ "HOME" | translate | titlecase }}</span></a
                  >
                </li>
                <!-- CPI -->
                <li *ngIf="roleID == userRoles.CPI" class="nav-item">
                  <a
                    #navlink2
                    href="javascript:void(0)"
                    (click)="clearFocus(navlink2); changeTitle('ISCR_BEN')"
                    [routerLink]="['/servizi/cpi/iscrizione-beneficiari']"
                    routerLinkActive="active"
                    class="nav-link nav-link-custom"
                    [attr.aria-current]="
                      isCurrentRoute('/servizi/cpi/iscrizione-beneficiari')
                        ? 'page'
                        : null
                    "
                    ><span>{{ "ISCR_BEN" | translate }}</span></a
                  >
                </li>
                <!-- ENTE -->
                <li *ngIf="roleID == userRoles.ENTE" class="nav-item">
                  <a
                    #navlink2
                    href="javascript:void(0)"
                    (click)="clearFocus(navlink2); changeTitle('GEST_OFF_FORM')"
                    [routerLink]="['/servizi/ente/gestione-offerte-formative']"
                    routerLinkActive="active"
                    class="nav-link nav-link-custom"
                    [attr.aria-current]="
                      isCurrentRoute('/servizi/ente/gestione-offerte-formative')
                        ? 'page'
                        : null
                    "
                    ><span>{{ "GEST_OFF_FORM" | translate }}</span></a
                  >
                </li>

                <li *ngIf="roleID == userRoles.ENTE" class="nav-item">
                  <a
                    #navlink3
                    href="javascript:void(0)"
                    (click)="clearFocus(navlink3); changeTitle('GEST_CLASS')"
                    [routerLink]="['/servizi/ente/gestione-classi']"
                    routerLinkActive="active"
                    class="nav-link nav-link-custom"
                    [attr.aria-current]="
                      isCurrentRoute('/servizi/ente/gestione-classi')
                        ? 'page'
                        : null
                    "
                    ><span>{{ "GEST_CLASS" | translate }}</span></a
                  >
                </li>

                <!-- REGIONE -->
                <li *ngIf="roleID == userRoles.REGIONE" class="nav-item">
                  <a
                    #navlink3
                    (click)="clearFocus(navlink3); changeTitle('GEST_CLASS')"
                    [routerLink]="['/servizi/regione/gestione-classi']"
                    routerLinkActive="active"
                    class="nav-link nav-link-custom"
                    [attr.aria-current]="
                      isCurrentRoute('/servizi/regione/gestione-classi')
                        ? 'page'
                        : null
                    "
                    ><span>{{ "GEST_CLASS" | translate }}</span></a
                  >
                </li>

                <!-- DOCENTE -->
                <li *ngIf="roleID == userRoles.DOCENTE" class="nav-item">
                  <a
                    #navlink2
                    (click)="
                      clearFocus(navlink2); changeTitle('CONFIRM_LESSONS')
                    "
                    [routerLink]="['/servizi/docente/lezioni-odierne']"
                    routerLinkActive="active"
                    class="nav-link nav-link-custom"
                    [attr.aria-current]="
                      isCurrentRoute('/' + role) ? 'page' : null
                    "
                    ><span>{{ "CONFIRM_LESSONS" | translate }}</span></a
                  >
                </li>
                <!-- PRESIDENTE -->
                <li *ngIf="roleID == userRoles.PRESIDENTE" class="nav-item">
                  <a
                    #navlink2
                    href="javascript:void(0)"
                    (click)="clearFocus(navlink2)"
                    [routerLink]="['/servizi/presidente/calendario-esami']"
                    routerLinkActive="active"
                    class="nav-link nav-link-custom"
                    [attr.aria-current]="
                      isCurrentRoute('/servizi/presidente/calendario-esami')
                        ? 'page'
                        : null
                    "
                    ><span>{{ "EXAM_CALENDAR" | translate }}</span></a
                  >
                </li>
                <!-- TUTOR -->
                <li *ngIf="roleID == userRoles.TUTOR" class="nav-item">
                  <a
                    #navlink2
                    href="javascript:void(0)"
                    (click)="clearFocus(navlink2)"
                    [routerLink]="['/servizi/tutor/gestione-tirocini']"
                    routerLinkActive="active"
                    class="nav-link nav-link-custom"
                    [attr.aria-current]="
                      isCurrentRoute('/servizi/tutor/gestione-tirocini')
                        ? 'page'
                        : null
                    "
                    ><span>{{ "GESTIONE_TIROCINI" | translate }}</span></a
                  >
                </li>
              </ul>
            </section>
          </div>
        </nav>
      </div>
    </div>
  </div>
</div>
